import { db } from '$db/local/db';
import type { StudyGoal } from '$domain/types';
import { getActiveUserId } from '$core/identity/active-user';
import { newId, nowIso, notDeleted } from './common';

export interface UpdateStudyGoalInput {
  dailyMinutes: number;
  weeklyMinutes: number;
  activeDays: number[];
}

export async function getStudyGoal(
  userId = getActiveUserId()
): Promise<StudyGoal | undefined> {
  const rows = await db.studyGoals.where('userId').equals(userId).toArray();
  return rows.filter(notDeleted)[0];
}

export async function getOrCreateStudyGoal(
  userId = getActiveUserId()
): Promise<StudyGoal> {
  const existing = await getStudyGoal(userId);
  if (existing) return existing;
  const now = nowIso();
  const goal: StudyGoal = {
    id: newId(),
    userId,
    dailyMinutes: 60,
    weeklyMinutes: 300,
    activeDays: [1, 2, 3, 4, 5],
    createdAt: now,
    updatedAt: now,
    deletedAt: null
  };
  await db.studyGoals.add(goal);
  return goal;
}

export async function updateStudyGoal(
  input: UpdateStudyGoalInput
): Promise<StudyGoal> {
  const existing = await getOrCreateStudyGoal();
  await db.studyGoals.update(existing.id, {
    dailyMinutes: Math.max(0, Math.round(input.dailyMinutes)),
    weeklyMinutes: Math.max(0, Math.round(input.weeklyMinutes)),
    activeDays: [...input.activeDays].sort((a, b) => a - b),
    updatedAt: nowIso()
  });
  const updated = await db.studyGoals.get(existing.id);
  return updated!;
}